import { TemplateType } from '../setting/other/template/template.const';

export enum CampaignType {
  Call = 'call',
  Email = 'email',
  Zns = 'zns',
  Sms = 'sms',
}

export const CampaignTypeArray = [
  { id: CampaignType.Call, text: 'Gọi điện' },
  {
    id: CampaignType.Email,
    text: 'Gửi mail',
    templateType: TemplateType.Email,
  },
  { id: CampaignType.Sms, templateType: TemplateType.Sms, text: 'Gửi SMS' },
  { id: CampaignType.Zns, templateType: TemplateType.Zns, text: 'Gửi ZNS' },
];

export enum DialModes {
  Progressive = 'progressive',
  Predictive = 'Predictive',
  Manual = 'manual',
  Broadcast = 'broadcast',
  AutodialIvr = 'autodial-ivr',
  // AutodialDrop = 'autodial-drop',
}
export const DialModeArray = [
  { id: DialModes.Progressive, text: 'Progressive' },
  { id: DialModes.Predictive, text: 'Predictive' },
  { id: DialModes.Manual, text: 'Manual' },
  { id: DialModes.Broadcast, text: 'Broadcast' },
  { id: DialModes.AutodialIvr, text: 'Autodial-IVR' },
  // {id: DialModes.AutodialDrop, text: 'Tự đ��ng Drop'},
];



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/campaign/campaign.const.ts